import * as React from "react";
import "../index.scss";
import { ViewPendencyInput } from "./ViewPendencyInput";
import { Collapse } from 'antd';
import { ITradePendency } from 'src/services/interfaces/pendency/ITradePendency';
import { PendencyStatusEnum } from 'src/services/Enum/pendency/PendencyStatusEnum';

export function ViewPendencyModal(props: { pendencies: ITradePendency[] }) {
  const { Panel } = Collapse;
  return (
    <Collapse defaultActiveKey={['1']}>
      <Panel header="Pendencias Abertas" key="1">
        {props.pendencies.filter(p => PendencyStatusEnum[p.status] === PendencyStatusEnum.Opened || p.hasUpdates).map(p => (
          <ViewPendencyInput key={p.id} pendency={p} />
        ))}
      </Panel>
      <Panel header="Pendencias Fechadas" key="2">
        {props.pendencies.filter(p => PendencyStatusEnum[p.status] === PendencyStatusEnum.Closed && !p.hasUpdates).map(p => (
          <ViewPendencyInput key={p.id} pendency={p} />
        ))}
      </Panel>

    </Collapse>
  );
}

export default ViewPendencyModal;



// WEBPACK FOOTER //
// ./src/components/common/Pendency/ViewPendency/ViewPendencyModal.tsx